import { render, staticRenderFns } from "./PendingImages.vue?vue&type=template&id=683a2638&scoped=true&"
import script from "./PendingImages.vue?vue&type=script&lang=js&"
export * from "./PendingImages.vue?vue&type=script&lang=js&"
import style0 from "./PendingImages.vue?vue&type=style&index=0&id=683a2638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683a2638",
  null
  
)

export default component.exports